// Emergent-managed Google sign-in. Sends the visitor to the hosted Google flow and
// back to this same origin with #session_id=..., which AuthCallback exchanges.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleSignInButton({ label = "Continue with Google" }) {
  const start = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={start}
      data-testid="google-signin-button"
      className="w-full flex items-center justify-center gap-3 border border-[#1f1f1f] bg-[#f7f5f0] px-4 py-3 font-mono text-xs uppercase tracking-[0.2em] text-[#1f1f1f] transition-colors hover:bg-[#1f1f1f] hover:text-[#f7f5f0]"
    >
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.5l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.5 13.3l7.9 6.1C12.3 13.6 17.7 9.5 24 9.5z" />
        <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.6 5.9c4.5-4.1 7-10.2 7-17.6z" />
        <path fill="#FBBC05" d="M10.4 28.6A14.6 14.6 0 0 1 9.5 24c0-1.6.3-3.1.8-4.6l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.5 10.7l7.9-6.1z" />
        <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.6-5.9c-2.1 1.4-4.8 2.3-8 2.3-6.3 0-11.7-4.1-13.6-9.9l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
      </svg>
      {label}
    </button>
  );
}

export function OrDivider() {
  return (
    <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.25em] text-[#8a8a8a]">
      <span className="h-px flex-1 bg-[#d5cfc1]" />
      or
      <span className="h-px flex-1 bg-[#d5cfc1]" />
    </div>
  );
}
